const propertiesIAlarmsLowecase = [
    'lowlevelenable',
    'lowlevelthreshold',
    'highlevelenable',
    'highlevelthreshold',
    'highhighenable',
    'highhighthreshold',
    'batterylowenable',
    'batterylowthreshold'
]

const propertiesIAlarmsExtendedLowecase = [
    'fullpipeenable',
    'fullpipethreshold',
    'overflowenable',
    'tiltenable',
    'tiltthreshold',
]

/** Incosistency between API responses, remove when it will be fixed */
export interface AlarmsStandard {
    lowlevelenable: boolean;
    lowlevelthreshold: number;
    highlevelenable: boolean;
    highlevelthreshold: number;
    highhighenable: boolean;
    highhighthreshold: number;
    batterylowenable: boolean;
    batterylowthreshold: number;
}

/** Incosistency between API responses, remove when it will be fixed */
export interface AlarmsExtended extends AlarmsStandard {
    fullpipeenable: boolean;
    fullpipethreshold: number;
    overflowenable: boolean;
    tiltenable: boolean;
    tiltthreshold: number;
}

function checkAll(obj: unknown, properties: string[]) {
    if(!obj) return false;

    for(const p of properties) {
        if(!obj.hasOwnProperty(p)) return false;
    }
    return true;
}

export function isIAlarmsLowecase(obj: unknown): obj is AlarmsStandard {
    return checkAll(obj, propertiesIAlarmsLowecase);
}
export function isIAlarmsExtendedLowecase(obj: unknown): obj is AlarmsExtended {
    return checkAll(obj, propertiesIAlarmsExtendedLowecase);
}

export interface AlarmDevice {
    rainEnable: boolean;
    rainThreshold: number;
    rainReturnToNormal: number;
    batteryLowEnable: boolean;
    batteryLowThreshold: number;
    batteryDeadEnable: boolean;
    temperatureInternalEnable: boolean;
    temperatureExternalEnable: boolean;
    temperaturePseudoEnable: boolean;
    lowLevelEnable: boolean;
    lowLevelThreshold: number;
    highLevelEnable: boolean;
    highLevelThreshold: number;
    highHighEnable: boolean;
    highHighThreshold: number;
    fullPipeEnable: boolean;
    fullPipeThreshold: number;
    overflowEnable: boolean;
    overflowThreshold: number;
    tiltEnable: boolean;
    tiltThreshold: number;
    unidepthsToAverage: number;
    highFlowEnable: boolean;
    highFlowThreshold: number;
}


export function translateAlarmDeviceToAlarmsStandard(originalAlarms: AlarmDevice): AlarmsStandard {
    return {
        lowlevelenable: originalAlarms.lowLevelEnable,
        lowlevelthreshold: originalAlarms.lowLevelThreshold,
        highlevelenable: originalAlarms.highLevelEnable,
        highlevelthreshold: originalAlarms.highLevelThreshold,
        highhighenable: originalAlarms.highHighEnable,
        highhighthreshold: originalAlarms.highHighThreshold,
        batterylowenable: originalAlarms.batteryLowEnable,
        batterylowthreshold: originalAlarms.batteryLowThreshold
    }
}


export function translateAlarmDeviceToAlarmsExtended(originalAlarms: AlarmDevice): AlarmsExtended {
    return {
        ...translateAlarmDeviceToAlarmsStandard(originalAlarms),
        fullpipeenable: originalAlarms.fullPipeEnable,
        fullpipethreshold: originalAlarms.fullPipeThreshold,
        overflowenable: originalAlarms.overflowEnable,
        tiltenable: originalAlarms.tiltEnable,
        tiltthreshold: originalAlarms.tiltThreshold
    }
}

export function translateAlarmsStandardToAlarmDevice(originalAlarms: AlarmsStandard): Partial<AlarmDevice> {
    return {
        batteryLowEnable: originalAlarms.batterylowenable,
        batteryLowThreshold: originalAlarms.batterylowthreshold,
        lowLevelEnable: originalAlarms.lowlevelenable,
        lowLevelThreshold: originalAlarms.lowlevelthreshold,
        highLevelEnable: originalAlarms.highlevelenable,
        highLevelThreshold: originalAlarms.highlevelthreshold,
        highHighEnable: originalAlarms.highhighenable,
        highHighThreshold: originalAlarms.highhighthreshold
    }
}

export function translateAlarmsExtendedToAlarmDevice(originalAlarms: AlarmsExtended): Partial<AlarmDevice> {
    return {
        ...translateAlarmsStandardToAlarmDevice(originalAlarms),
            fullPipeEnable: originalAlarms.fullpipeenable,
            fullPipeThreshold: originalAlarms.fullpipethreshold,
            overflowEnable: originalAlarms.overflowenable,
            tiltEnable: originalAlarms.tiltenable,
            tiltThreshold: originalAlarms.tiltthreshold
    }
}
